export default __webpack_public_path__ + "static/media/img-54.c5c7d82f.jpg";